import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {PoiType} from "@pg-mono/open-street-map";
import {IActivePoiDirections, IPoi, IPoiDirectionsData, IPublicTransportRoute, IUserPoi, TravelMode} from "@pg-mono/osm-with-poi";

import {RootState} from "../../../store/types/RootState";

export interface IMapUiState {
    activePoi: IPoi | IUserPoi | null;
    activePoiDirections: IActivePoiDirections | null;
    activePoiRoute: IPublicTransportRoute | null;
    activePoiType: PoiType | null;
    poisDirections: Record<number, Record<string, IPoiDirectionsData>>;
}

const initialState: IMapUiState = {
    activePoi: null,
    activePoiDirections: null,
    activePoiRoute: null,
    activePoiType: null,
    poisDirections: {}
};

export const mapUiSlice = createSlice({
    name: "mapUi",
    initialState,
    reducers: {
        resetMapUi: () => initialState,
        setActivePoi: (state, action: PayloadAction<{poi: IPoi | IUserPoi | null; poiType: PoiType | null}>) => {
            state.activePoi = action.payload.poi;
            state.activePoiType = action.payload.poiType;
        },
        setActivePoiDirections: (state, action: PayloadAction<IActivePoiDirections | null>) => {
            state.activePoiDirections = action.payload;
        },
        setActivePoiRoute: (state, action: PayloadAction<IPublicTransportRoute | null>) => {
            state.activePoiRoute = action.payload;
        },
        setPoisDirections: (state, action: PayloadAction<{data: IPoiDirectionsData; id: number; travelMode: TravelMode}>) => {
            const {data, id, travelMode} = action.payload;
            const current = state.poisDirections[id] ?? {};

            state.poisDirections[id] = {
                ...current,
                [travelMode]: data
            };
        }
    }
});

export const {resetMapUi, setActivePoi, setActivePoiDirections, setActivePoiRoute, setPoisDirections} = mapUiSlice.actions;

export const selectMapUi = (state: RootState) => state.mapUi;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {PoiType} from "@pg-mono/open-street-map";
import {IActivePoiDirections, IPoi, IPoiDirectionsData, IPublicTransportRoute, IUserPoi, TravelMode} from "@pg-mono/osm-with-poi";

import {RootState} from "../../../store/types/RootState";

export interface IMapUiState {
    activePoi: IPoi | IUserPoi | null;
    activePoiDirections: IActivePoiDirections | null;
    activePoiRoute: IPublicTransportRoute | null;
    activePoiType: PoiType | null;
    poisDirections: Record<number, Record<string, IPoiDirectionsData>>;
}

const initialState: IMapUiState = {
    activePoi: null,
    activePoiDirections: null,
    activePoiRoute: null,
    activePoiType: null,
    poisDirections: {}
};

export const mapUiSlice = createSlice({
    name: "mapUi",
    initialState,
    reducers: {
        resetMapUi: () => initialState,
        setActivePoi: (state, action: PayloadAction<{poi: IPoi | IUserPoi | null; poiType: PoiType | null}>) => {
            state.activePoi = action.payload.poi;
            state.activePoiType = action.payload.poiType;
        },
        setActivePoiDirections: (state, action: PayloadAction<IActivePoiDirections | null>) => {
            state.activePoiDirections = action.payload;
        },
        setActivePoiRoute: (state, action: PayloadAction<IPublicTransportRoute | null>) => {
            state.activePoiRoute = action.payload;
        },
        setPoisDirections: (state, action: PayloadAction<{data: IPoiDirectionsData; id: number; travelMode: TravelMode}>) => {
            const {data, id, travelMode} = action.payload;
            const current = state.poisDirections[id] ?? {};

            state.poisDirections[id] = {
                ...current,
                [travelMode]: data
            };
        }
    }
});

export const {resetMapUi, setActivePoi, setActivePoiDirections, setActivePoiRoute, setPoisDirections} = mapUiSlice.actions;

export const selectMapUi = (state: RootState) => state.mapUi;
